import React from 'react';
import { View } from 'react-native-web';
import UploadContainer from './UploadContainer';
import Details from '../Text/Details';
import AddDisabledMode from '../Buttons/AddDisabledMode';
import SubTitle from '../Text/SubTitle';

//= ========================================================================

const UploadMenu = ({
  globJSON,
  onConfigChanged,
  headline,
  details,
  listObject,
  TwoButtonsInARow,
  marginTop = 0,
  marginBottom = 30,
}) => (
  <View style={{
    marginBottom,
    marginTop,
  }}
  >
    <SubTitle marginBottom={3} isBold>{headline}</SubTitle>
    <Details marginBottom={12}>{details}</Details>
    <View style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 20,
    }}
    >
      {listObject.filter((object) => !object.isHide).map((object) => (
        <View>
          {object.disableMode
            ? <AddDisabledMode globJSON={globJSON} onConfigChanged={onConfigChanged} object={object} />
            : (
              <UploadContainer
                globJSON={globJSON}
                onConfigChanged={onConfigChanged}
                listObject={object}
                TwoButtonsInARow={TwoButtonsInARow}
              />
            )}
        </View>
      ))}
    </View>
  </View>

);
export default UploadMenu;
